// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1rbVD","inputWrap":"Table_inputWrap__2r63T","col":"Table_col__2A8iI","bmiTooltip":"Table_bmiTooltip__29yS7"};